import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import auth from '@/service/auth';

//restful api
import { user as manager } from '@/service/api/manager'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});
// props explain
// auto_refresh : auth sync enable or disable, value is boolean
// group : this component to group list, using by group dependency

const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    { key: 'group.groupname', sortable: true, label: 'Group' },
    { key: 'status', sortable: false, label: 'Allow login' },
    { key: 'permissions', sortable: true, label: 'Permission', thStyle: 'width: 10%' },
    { key: 'username', sortable: true, label: 'Username'},
    { key: 'last_visit', label: 'Last_visit', sortable: true, thStyle : 'width: 10%' },
  ],
  KO: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    { key: 'group.groupname', sortable: true, label: '회사명' },
    { key: 'status', sortable: false, label: '로그인 허용' },
    { key: 'permissions', sortable: true, label: '권한', thStyle: 'width: 10%' },
    { key: 'username', sortable: true, label: '사용자명'},
    { key: 'last_visit', label: '마지막 접속일', sortable: true, thStyle : 'width: 10%' },
  ]
}

export default {
  name : "userList",
  props: ['group', "auto_refresh", "view_detail", "enable_new", "delay"],
  watch: {
    group() {
      console.log("watch updated props data", this.group.groupname)
      this.$refs._list.refresh();
    },
    '$route' (to, from) { console.log("from", from); this.$on('refresh', this.refresh()) }
  },
  components: { DatePicker, vSelect },
  data: () => ({
    auth,
    hide_del : true,
    codes,
    custom,
    so : default_opt(),
    sync : { th : undefined, stop : false, interval : 15, enable : false },
    summaryData : { enable : 0, disable : 0, total : 0 }, //enable : is_alive 기준, disable : is_del 기준
    model : {},
    nbsp : "\u00A0"
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n]
    }
  },
  methods: {
    has_permissions() { return this.enable_new !== false && ((this.group && this.group.id) || auth.profile.permissions.toLowerCase() != 'sales')  },
    change_alive($event) { if($event == true || $event == false) { this.so.opt['is_alive'] = $event; this.refresh(); } },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['last_visit_ed'] = moment()
        this.so.opt['match_type'] = 'and';
        this.so.opt['is_alive'] = 'true';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    summary() {
      manager.summaryUser(Object.assign({}, this.group ? { params : { id : this.group.id, ts : new Date().getTime() }} : { ts : new Date().getTime()}))
        .then(rs => { this.summaryData = Object.assign({}, this.summaryData, { enable : (rs.body.total - rs.body.disable), disable : rs.body.disable, total : rs.body.total }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    add() {
      if(this.view_detail !== false) {
        this.$router.push({ name: 'user', params: { id : 'add' } })
      } else {
        this.$router.push({ name: 'user', params: { id : this.$route.params.id, tag : "group" } })
      }
    },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : []
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.group) { so.body.and.push({ name : 'group_id', value : this.group.id, op : '='}) }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'permissions':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'last_visit_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'last_visit_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return manager.listUser(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText))
    },
    goDetail(item) { this.$router.push({ name : "user", params : { id : item.id } }); },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  created() { console.log('User_List.vue', 'created'); },
  destroyed() { console.log('User_List.vue', 'destroyed'); },
  mounted() { console.log('User_List.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(!this.view_detail !== false) {
      // not component
      this.summary()
    }
  },
}